let appleSdkPromise = null;

export function loadApplePaySDK() {
  if (appleSdkPromise) {
    return appleSdkPromise;
  }

  appleSdkPromise = new Promise((resolve, reject) => {
    if (customElements.get('apple-pay-button')) {
      return resolve();
    }

    const applePaySrc = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';
    let applePay = document.createElement('script');
    applePay.setAttribute('src', applePaySrc);
    applePay.setAttribute('crossorigin', 'anonymous');
    applePay.onload = () => resolve();
    applePay.onerror = () => reject(new Error('Failed to load Apple Pay SDK'));
    document.head.appendChild(applePay);
  });

  return appleSdkPromise;
}

let googleSdkPromise = null;

export function loadGooglePaySDK() {
  if (googleSdkPromise) return googleSdkPromise;

  googleSdkPromise = new Promise((resolve, reject) => {
    if (window.google?.payments?.api?.PaymentsClient) {
      return resolve();
    }

    const script = document.createElement('script');
    script.src = 'https://pay.google.com/gp/p/js/pay.js';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Google Pay SDK'));
    document.head.appendChild(script);
  });

  return googleSdkPromise;
}
